import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

const ScrollToField = ({ order = [] }) => {
  const { errors, isSubmitting, isValidating } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      let errorKeys = Object.keys(errors);
      if (errorKeys.length > 0) {
        let firstErrorKey = errorKeys[0];
        order.some((key) => {
          if (errorKeys.includes(key)) {
            firstErrorKey = key;
            return true;
          }
          return false;
        });
        const errorElement = document.getElementById(firstErrorKey);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          errorElement.focus({ preventScroll: true });
        }
      }
    }
  }, [errors, isSubmitting, isValidating]);

  return null;
};

export default ScrollToField;
